module.exports = __webpack_public_path__ + "static/media/right-col-packshot.ee24b0d7.png";